<template>
    <div
      @click="selectCategory"
      :class="getPholderClass">

    <div class="m-0 w-100">
      <div class="qheadding qbold">
          <div :class="siteImageClass(isIcon)">
            <q-icon
              class="qicon"
              :allowSelfUpdate="false"
              width="20px"
              height="20px"
              :name="getSiteImageName"
              :pack="getSiteImagePack" />

          </div>

          <span class="category-label">
            {{ $t(getSiteLabel) }}
          </span>
        </div>
      </div>

    <div class="m-0 w-100">
    <div class="qbody">
      <div class="m-0 centered">
        <div class="p-0">
          <p>
            {{ $t(site.description) }}
          </p>
        </div>
      </div>
      <input-button
        variant="standardInput"
        btnStyle="ok-style"
        smaller
        hollow
        centered
        :inputPlaceholder="getButtonLabel" />

    </div>
  </div>
</div>
</template>

<script>
import InputButton from '@/components/standard/input/InputButton'
import QImage from '@/components/standard/display/QImage'
import QIcon from '@/components/standard/display/QIcon'

export default {
  methods: {
    selectCategory (e) {
      this.$emit('selectCategory', {
        selected: this.site.connected,
        name: this.site.name,
        route: this.site.route,
        params: this.site.params
      })
    },
    siteImageClass (isIcon) {
      let base = 'category-image'
      return base
    }
  },
  components: {
    'q-image': QImage,
    'q-icon': QIcon,
    'input-button': InputButton
  },
  computed: {
    getPholderClass () {
      let base = 'p-0 m-0 page-pholder'
      if (this.connectable) {
        base += ' connected'
      }
      return base
    },
    isIcon () {
      return !!this.site.icon
    },
    getSiteImageName () {
      return this.site.icon
    },
    getSiteImagePack () {
      return this.site.pack
    },
    getSiteLabel () {
      return this.site.label
    },
    getButtonLabel () {
      return this.site.buttonLabel
    },
    isConnectable () {
      return this.connectable
    },
    isEditable () {
      return this.editable
    },
    isViewable () {
      return this.viewable
    }
  },
  props: {
    site: {
      type: Object,
      required: true,
      default: () => {{}}
    },
    connectable: {
      type: Boolean,
      required: false,
      default: false
    },
    editable: {
      type: Boolean,
      required: false,
      default: false
    },
    viewable: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped>
.page-pholder {
  background-color: #ffffff;
  display: flex;
  height: 100%;
  flex-wrap: wrap;
}
.qheadding {
  margin-right: 1px;
  min-height: 50px;
  padding: 10px 15px;
  border-bottom: 2px solid #F8F8F8;
}
.qbody {
  padding-top: 20px;
  padding-bottom: 20px;
  min-height: 160px;
  display: flex;                
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 20px 30px;
}
.qbody p{
  font-size: 13px;
}
.category-image {
  overflow: hidden;
  width: 25px;
  height: 25px;
  background-color: #FFF;
  border-radius: 100%;
  margin-left: 10px;
  /* border: 1px solid #D2D3D4; */
  float: left;

  display: flex;
  align-items: center;
  justify-content: center;
  color: #7AC143;
}
.category-label {
  margin-left: 15px;
  font-size: 14px;
  font-weight: bold;
}
.site-buttons {
  margin-top: 25px;
}
.centered {
  margin: 0 auto;
}
.padded {
  padding: 5px;
}
.image-background {
  background-color: #F8F8F8;
  border-radius: 100%;
  width: 70px;
  height: 70px;
}
.connected-text {
  margin-left: 10px;
}

.qicon {
  border-radius: 50%;
}

</style>



// WEBPACK FOOTER //
// src/components/service/campaignManager/CategoryPholder.vue?ca0ec1da